<script lang="ts">
    import { taskMap } from '@/data/tasks';
    import { settingsState } from '@/shared/state/settings.svelte';
    import { timeState } from '@/shared/state/time.svelte';
    import { componentTooltip } from '@/shared/utils/tooltips';
    import { activeViewTasks } from '@/user-home/state/activeViewTasks.svelte';
    import { userState } from '@/user-home/state/user';
    import type { SortableProps } from '@/types/props';

    import IconifyWrapper from '@/shared/components/images/IconifyWrapper.svelte';
    import ParsedText from '@/shared/components/parsed-text/ParsedText.svelte';
    import Tooltip from '@/components/tooltips/task/TooltipTaskHead.svelte';

    let { getSortState, setSortState }: SortableProps = $props();

    let activeTasks = $derived(activeViewTasks.value);
</script>

<style lang="scss">
    td {
        --scale: 0.5;

        word-spacing: -0.2ch;

        :global([data-string='exclamation']) {
            margin-left: -0.3rem;
        }
    }
    .decorator-warn {
        box-shadow: inset 0 0 5px 3px color-mix(in hsl, var(--color-warn) 75%, #000);
    }
    .decorator-shrug {
        box-shadow: inset 0 0 5px 3px color-mix(in hsl, var(--color-shrug) 75%, #000);
    }
    .decorator-success {
        box-shadow: inset 0 0 5px 3px color-mix(in hsl, var(--color-success) 75%, #000);
    }
</style>

{#each activeTasks as fullTaskName (fullTaskName)}
    {@const [taskName, choreName] = fullTaskName.split('|', 2)}
    {@const task = taskMap[taskName] || settingsState.customTaskMap[fullTaskName]}
    {@const chore = task.chores.find((task) => task?.key === choreName)}
    {@const customExpiry = chore?.customExpiryFunc?.(
        chore,
        userState.general.characters[0],
        timeState.slowTime
    )}
    {@const decoratorClass = chore?.decorationFunc?.(customExpiry)}

    <td
        class="sortable sorted-{getSortState(fullTaskName)} {decoratorClass || ''}"
        data-task={taskName}
        style:--scale="1"
        onclick={() => setSortState(fullTaskName)}
        use:componentTooltip={{
            component: Tooltip,
            props: {
                chore,
                expiresAt: customExpiry,
                fullTaskName,
                task,
            },
        }}
    >
        {#if chore}
            {#if chore.icon}
                {#if typeof chore.icon === 'string'}
                    <ParsedText text={chore.icon} />
                {:else}
                    <IconifyWrapper icon={chore.icon} />
                {/if}
            {/if}
        {:else}
            <ParsedText text={task.shortName} />
        {/if}
    </td>
{/each}
